module.exports = __webpack_public_path__ + "static/media/iphone_hand.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dummy-images/iphone_hand.png
// module id = ./src/assets/dummy-images/iphone_hand.png
// module chunks = 0